export default "__VITE_ASSET__Bywi9OP8__"